import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-ext";
var SinkView = /** @class */ (function (_super) {
    tslib_1.__extends(SinkView, _super);
    function SinkView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sinkPopupOpen = false;
        _this.moveNextPrevented = false;
        _this.moveNextTimer = null;
        return _this;
    }
    SinkView.prototype.moveNext = function () {
        this.moveNextPrevented = true;
        var self = this;
        this.moveNextTimer = setTimeout(function () { return self.moveNextPrevented = false; }, 3000);
    };
    Object.defineProperty(SinkView.prototype, "sinkLeftMargin", {
        get: function () {
            var margin = this.$ui.sink.margins;
            if (this.$state.sink == 'E' && (this.$state.faucetHole == 'L' || this.$state.extraHole == 'L' || this.$state.extraHole2 == 'L'))
                margin = 110;
            if (this.$state.sink == 'N' && this.$ui.worktopWidth <= 500 && (this.$state.faucetHole == 'L' || this.$state.extraHole == 'L' || this.$state.extraHole2 == 'L'))
                margin = 90;
            if (this.$state.sinkDistanceMeasuredTo == 'center')
                margin += this.$ui.sink.length / 2;
            return margin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SinkView.prototype, "sinkRightMargin", {
        get: function () {
            var margin = this.$ui.sink.margins;
            if (this.$state.sink == 'E' && (this.$state.faucetHole == 'R' || this.$state.extraHole == 'R' || this.$state.extraHole2 == 'R'))
                margin = 110;
            if (this.$state.sink == 'N' && this.$ui.worktopWidth <= 500 && (this.$state.faucetHole == 'R' || this.$state.extraHole == 'R' || this.$state.extraHole2 == 'R'))
                margin = 90;
            if (this.$state.sinkDistanceMeasuredTo == 'center')
                margin += this.$ui.sink.length / 2;
            return margin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SinkView.prototype, "sinkMeasurementTypes", {
        get: function () {
            return {
                title: null,
                options: [
                    {
                        value: "edge",
                        text: this.$ui.t("sinkToEdge"),
                        image: null,
                        embedMedia: null,
                        link: null,
                        disabled: false,
                        visible: true,
                        warnings: [],
                        messages: []
                    },
                    {
                        value: "center",
                        text: this.$ui.t("sinkToCenter"),
                        image: null,
                        embedMedia: null,
                        link: null,
                        disabled: false,
                        visible: true,
                        warnings: [],
                        messages: []
                    }
                ]
            };
        },
        enumerable: true,
        configurable: true
    });
    SinkView.prototype.created = function () {
        if (!this.$state.sink)
            this.toggleSinkSelection();
    };
    SinkView.prototype.toggleSinkSelection = function () {
        this.sinkPopupOpen = !this.sinkPopupOpen;
    };
    Object.defineProperty(SinkView.prototype, "sinkPropertiesVisible", {
        get: function () {
            return this.$ui.sinkIsValid && this.$state.sink && this.$ui.sink.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    SinkView = tslib_1.__decorate([
        Component
    ], SinkView);
    return SinkView;
}(Vue));
export default SinkView;
